import { render } from "./DonateBox.vue?vue&type=template&id=ec570c3a&scoped=true"
import script from "./DonateBox.vue?vue&type=script&lang=js"
export * from "./DonateBox.vue?vue&type=script&lang=js"

import "./DonateBox.vue?vue&type=style&index=0&id=ec570c3a&scoped=true&lang=css"

import exportComponent from "C:\\code\\kascenskaforvt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec570c3a"]])

export default __exports__